import { type Device } from '@/portal-api.definition';
import { WooTablet, WooSmartphone, WooLaptop, GameController, WooTv } from '@nosinovacao/fe-icons';

export const DeviceIconMap: Record<
  Device['Type'],
  React.ComponentType<{ width: number; height: number; className?: string }>
> = {
  ANDROIDTABLET: WooTablet,
  IOSTABLET: WooTablet,
  ANDROIDSMARTPHONE: WooSmartphone,
  IOSSMARTPHONE: WooSmartphone,
  PC: WooLaptop,
  MAC: WooLaptop,
  XBOX: GameController,
  PS4: GameController,
  ANDROIDTV: WooTv,
  APPLETV: WooTv,
};
